import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api`;

export const ncTrackingService = {
  /**
   * Get all NC tracking records for a specific entity
   */
  async getEntityNonConformances(entityType, entityId) {
    const response = await fetch(
      `${API_BASE}/nc-tracking/entity/${entityType}/${entityId}`
    );
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
  },

  /**
   * Get all open/in_correction NCs across all entities
   */
  async getOpenNonConformances(filters = {}) {
    const params = new URLSearchParams();
    if (filters.entityType) params.append('entityType', filters.entityType);
    if (filters.severity) params.append('severity', filters.severity);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await fetch(
      `${API_BASE}/nc-tracking/open?${params.toString()}`
    );
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
  },

  /**
   * Get NC tracking statistics
   */
  async getStatistics() {
    const response = await fetch(`${API_BASE}/nc-tracking/statistics`);
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
  },

  /**
   * Mark NC as in_correction when user starts fixing
   */
  async startCorrection(ncId, correctedBy, correctionNotes) {
    const response = await fetch(
      `${API_BASE}/nc-tracking/${ncId}/start-correction`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ correctedBy, correctionNotes })
      }
    );
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
  },

  /**
   * Resubmit a corrected entity for verification
   */
  async resubmitCorrected(entityType, entityId, options = {}) {
    const response = await fetch(
      `${API_BASE}/verification/resubmit-corrected`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({ entityType, entityId, options })
      }
    );
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
  }
};
